/* istanbul ignore file */
// Allows integers or decimals with up to 2 digits after the decimal point (e.g., 1, 2, 1.5, 1.45)
const decimalNumberRegex = /^(0|[1-9]\d*)(\.\d{1,2})?$/;

export default {
  requestType: { type: 'enum', required: true },
  reasonForChange: { type: 'string', required: true },
  changes: {
    type: 'array',
    required: true,
    minSize: 1,
    forEach: {
      type: 'object',
      _divisible: false,
      properties: {
        ticketId: {
          type: 'string',
          required: true,
        },
        trackingDate: {
          type: 'date',
          required: true,
        },
        timeEntryId: {
          type: 'string',
          required: {
            value: true,
            when: {
              $requestType: {
                eq: 'EXISTING_TIME_ADJUSTMENT',
              },
            },
          },
        },
        currentTimeTrack: {
          type: 'string',
          required: true,
        },
        correctTicketId: {
          type: 'string',
          required: {
            value: true,
            when: {
              $requestType: {
                eq: 'EXISTING_TIME_ADJUSTMENT',
              },
            },
          },
        },
        correctTrackingDate: {
          type: 'date',
          required: {
            value: true,
            when: {
              $requestType: {
                eq: 'EXISTING_TIME_ADJUSTMENT',
              },
            },
          },
        },
        correctTimeTrack: {
          type: 'string',
          required: {
            value: true,
            when: {
              $requestType: {
                eq: 'EXISTING_TIME_ADJUSTMENT',
              },
            },
          },
          regex: {
            value: decimalNumberRegex,
            message: 'Must be a decimal number with up to 2 decimal places (e.g., 0, 0.1, 1.45)',
          },
        },
        activity: {
          type: 'string',
          required: {
            value: true,
            when: {
              $requestType: {
                eq: 'NEW_TIME_ENTRY',
              },
            },
          },
        },
        descriptionOfWork: {
          type: 'string',
          required: {
            value: true,
            when: {
              $requestType: {
                eq: 'NEW_TIME_ENTRY',
              },
            },
          },
          maxSize: 1000,
        },
      },
    },
  },
};
